import { store } from 'stores/Store';
import styles from './RoutesTab.module.scss';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { isTransientLocationPin, resolveFindOnMapLatLon } from './findOnMapPin';

interface IRoutesTab {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onSelect: (opt: string) => void;
  onPractitionerAdded?: () => void;
  onFindOnMap?: (practitioner: any, latLon: [number, number]) => void;
  /**
   * EIS-1061: the actually-selected map pin, when the modal is opened from a
   * map pin (MapComponent's local `selectedPractitioner`). There,
   * `store.currentPractitioner` can be stale or unset — especially for
   * transient Google Places search-result pins, which never populate the
   * store. Pass `null` for "nothing selected" (hides the pin-dependent rows).
   * When omitted (undefined), falls back to `store.currentPractitioner`
   * (legacy BaseballCard flow, unchanged).
   */
  pin?: any;
}

const RoutesTab = ({ isOpen, setIsOpen, onSelect, onPractitionerAdded, onFindOnMap, pin }: IRoutesTab) => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const location = useLocation();

  // Single source of truth for both the row gating and the coordinates the
  // click handlers use: the explicitly-passed pin, or the store fallback.
  const sourcePin = pin !== undefined ? pin : store?.currentPractitioner;
  const findOnMapLatLon = resolveFindOnMapLatLon(sourcePin);

  return (
    <div style={{ display: isOpen ? 'block' : 'none', zIndex: 4000 }}>
      <div 
        className={styles.overlay} 
        onClick={() => setIsOpen(false)}
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 5002,
          height: '300%',
          width: '100%',
        }}
      />
      <div className={styles.optsWrapper}>
        <div style={{
          maxHeight: '400px',
          overflowY: 'auto'
        }}>
          <div className={styles.headerWrapper}>
            <p style={{ fontSize: '16px', fontWeight: '500', textAlign: 'center' }}>Open route in:</p>
          </div>

          <button
            className={styles.btn}
            onClick={() => onSelect('google')}
          >
            <p className={styles.smallText}>Google Maps</p>

          </button>
          <button
            className={styles.btn}
            onClick={() => onSelect('waze')}
          >
            <p className={styles.smallText}>Waze</p>
          </button>
          <button
            className={styles.btn}
            onClick={() => onSelect('apple')}
          >
            <p className={styles.smallText}>Apple Maps</p>
          </button>
          {findOnMapLatLon && (
            <button
              className={styles.btn}
              onClick={() => {
                if (onFindOnMap) {
                  onFindOnMap(sourcePin, findOnMapLatLon)
                } else {
                  navigate({
                    search: createSearchParams({
                      lat: findOnMapLatLon[0] + "",
                      lon: findOnMapLatLon[1] + "",
                      id: sourcePin?.id + "",
                      }).toString(),
                    pathname: "/mapView",
                  }, {
                    replace: true,
                  });
                }
                setIsOpen(false);
              }}
            >
              <p className={styles.smallText}>Find on Map</p>
            </button>

          )}
          {/* EIS-1061: routes are built from DB records; transient Google
              Places pins (type 3) have no DB practitioner to add, so the row
              is hidden for them while Find on Map above stays available. */}
          {findOnMapLatLon && !isTransientLocationPin(sourcePin) && (
            <button
              className={styles.btn}
              onClick={() => {
                store.addToRoute(sourcePin);
                setIsOpen(false);
                onPractitionerAdded?.();
              }}
            >
              <p className={styles.smallText}>Add to route</p>
            </button>
          )}
          {/*
        <button
          className={styles.btn}
          onClick={() => onSelect('website')}
        >
          WEBSITE
          <p className={styles.smallText}>{store.currentPractitioner?.website}</p>
        </button>
        */}
        </div>
      </div>

      <div className={styles.cancelWrapper}>
        <button
          onClick={() => setIsOpen(false)}
          style={{
            background: 'none',
            color: '#000',
            fontSize: '17px',
            margin: '5px',
            borderRadius: '10px',
            border: 'none'
          }}
        >
          CANCEL
        </button>
      </div>
    </div>
  );
};

export default RoutesTab;
